module.exports = __webpack_public_path__ + "static/media/BanyantreeLogo.f4c79ceb.png";